/* eslint-disable react/no-multi-comp */
import React, { PureComponent } from 'react';
import { t } from 'i18next';
import { arrayOf, string, func, bool, object, oneOfType } from 'prop-types';
import cn from 'classnames';
import { IonIcon } from '@ionic/react';
import { warningOutline } from 'ionicons/icons';

import { TABS_DATA } from '../../constants';

import SimpleSpinner from '~components/SimpleSpinner';
import { subsidiaryPropTypes } from '~propTypes/subsidiary';
import { addressPropTypes } from '~propTypes/address';
import storePropTypes from '~constants/propTypes';
import { DISPATCH_METHODS } from '~constants/address';
import { normalizeCoordinates } from '~utils/maps';
import { MAP_SIZE, MAP_SCALE, QUALITY } from '~constants/maps';
import StaticMap from '~components/StaticMap';
import ErrorMessage from '~components/ErrorMessage';
import { ERROR_IMAGES } from '~components/ErrorMessage/constants';
import { RENDER_CALL_CENTER } from '~constants/environment';
import LocalStorageService from '~services/LocalStorageService';
import { DEFAULT_MAX_RESULTS } from '~screens/Dashboard/components/ChangeAddress/constants';
import StoreSearchBar from '~components/StoreSearchBar';

import Store from './components/Store';
import styles from './styles.module.scss';
import { getStoreKey, storesKeyMatch } from './utils';
import StoreInfoContainer from './components/StoreInfoContainer';

class PickUp extends PureComponent {
  state = {
    hoveredStore: null,
    location: normalizeCoordinates(this.props.selectedAddress),
    selectedStore: null,
    loading: false,
    selectedTime: null
  };

  componentDidMount = () => {
    const {
      onDispatchChange,
      stores,
      selectedStore: selectedStoreProps,
      searchStore,
      selectedDeliveryTime
    } = this.props;
    const { selectedStore } = this.state;
    if (!selectedStore && selectedStoreProps) {
      const nearStore = stores?.find(store => store.id === selectedStoreProps.id);
      this.setState({ selectedStore: nearStore });
    }
    onDispatchChange(DISPATCH_METHODS.IN_STORE);
    if (searchStore?.dispatchType === DISPATCH_METHODS.IN_STORE && selectedDeliveryTime) {
      this.handleSelectedTime(selectedDeliveryTime);
    }
  };

  handleConfirm = () => {
    const { onConfirm, setSelectedDeliveryTime } = this.props;
    const { selectedStore, selectedTime } = this.state;

    if (RENDER_CALL_CENTER) {
      this.setState(state => ({ ...state, loading: true }));
    }

    if (selectedTime?.time?.name) {
      LocalStorageService.setSelectedDeliveryTime(selectedTime, '', 60);
    } else {
      LocalStorageService.removeSelectedDeliveryTime();
    }
    setSelectedDeliveryTime(
      selectedTime ?? {
        now: t('Delivery:time', { time: selectedStore.pickUpWaitTime })
      }
    );

    onConfirm({
      store: selectedStore,
      type: DISPATCH_METHODS.IN_STORE,
      hotspot: selectedStore.hotspot || null,
      papaCar: selectedStore.papacar || null
    });
  };

  handleStoreSelect = store => {
    const { onStoreSelect } = this.props;

    this.setState({ selectedStore: store });
    onStoreSelect({ store });
  };

  handleStoreFocus = obj => {
    const { onStoreFocus } = this.props;
    const { hoveredStore } = this.state;
    const store = obj?.store || obj;
    if (!storesKeyMatch(hoveredStore, store)) {
      this.setState({ hoveredStore: store });
      onStoreFocus?.(store);
    }
  };

  onChangeToDelivery = () => {
    const { changeTab, onDispatchChange } = this.props;
    const deliveryTab = TABS_DATA.findIndex(tab => tab.value === DISPATCH_METHODS.PJ_DELIVERY);
    onDispatchChange(DISPATCH_METHODS.IN_STORE);
    changeTab(deliveryTab);
  };

  handleStoreBlur = () => {
    const { onStoreBlur } = this.props;

    this.setState({ hoveredStore: null });
    onStoreBlur?.();
  };

  handleSelectedTime = time => {
    this.setState({ selectedTime: time });
  };

  handleSelectedAddress = address => {
    const { onAddressSelect, undoConfirmAddress } = this.props;
    onAddressSelect(address);
    undoConfirmAddress();
  };

  handleCleanAddress = () => {
    const { onSearchInputChange, undoConfirmAddress } = this.props;
    onSearchInputChange();
    undoConfirmAddress();
  };

  storeInfo = className => {
    const { selectedStore, loading, selectedTime } = this.state;
    const { isConfirmAddress } = this.props;

    return (
      <StoreInfoContainer
        className={className}
        selectedStore={selectedStore}
        onConfirm={this.handleConfirm}
        loading={loading}
        isConfirmAddress={isConfirmAddress}
        selectedTime={selectedTime}
      />
    );
  };

  render() {
    const {
      stores,
      selectedStore,
      className,
      deliveryError,
      onCleanSearchInput,
      selectedAddress,
      onSearchInputChange,
      incompleteAddress,
      loadingStores,
      setScheduled
    } = this.props;
    const { hoveredStore, location, selectedTime } = this.state;
    const focusedStore = hoveredStore || selectedStore;

    if (!selectedAddress) {
      return (
        <div className={`full-width ${styles.searchBarContainer} m-bottom-4`}>
          <StoreSearchBar
            key="modalSearchBar"
            maxResults={DEFAULT_MAX_RESULTS}
            selectedAddress={selectedAddress}
            onAddressSelect={this.handleSelectedAddress}
            onChange={onSearchInputChange}
            onClean={this.handleCleanAddress}
            incompleteAddress={incompleteAddress}
            placeholder={t('DeliveryOrPickUp:searchPickUpPlaceholder')}
          />
        </div>
      );
    }

    return (
      <>
        <div className="full-width m-bottom-4">
          <StoreSearchBar
            key="modalSearchBar"
            maxResults={DEFAULT_MAX_RESULTS}
            selectedAddress={selectedAddress}
            onAddressSelect={this.handleSelectedAddress}
            onChange={onSearchInputChange}
            onClean={this.handleCleanAddress}
            incompleteAddress={incompleteAddress}
            placeholder={t('DeliveryOrPickUp:searchPickUpPlaceholder')}
          />
        </div>
        {loadingStores ? (
          <SimpleSpinner className="m-top-6" />
        ) : (
          <>
            {RENDER_CALL_CENTER && this.storeInfo(cn({ [styles.storeInfoContainerTop]: RENDER_CALL_CENTER }))}
            {deliveryError && stores && (
              <div className={styles.adressWarningContainer}>
                <div className={styles.iconWarning}>
                  <IonIcon icon={warningOutline} className={styles.iconWarning} />
                </div>
                <p>{t('DeliveryOrPickUp:deliveryWarning')}</p>
              </div>
            )}
            <div className={`row full-width m-bottom-2 ${styles.pickUp} ${className}`}>
              {stores ? (
                <>
                  <div className={`column full-width ${styles.cardContainer}`}>
                    {stores.map((store, index) => (
                      <Store
                        key={getStoreKey(store)}
                        store={store}
                        order={index + 1}
                        location={location}
                        focused={storesKeyMatch(focusedStore, store)}
                        onSelect={this.handleStoreSelect}
                        onMouseLeave={this.handleStoreBlur}
                        onMouseEnter={this.handleStoreFocus}
                        selectedStore={selectedStore}
                        onSelectedTime={this.handleSelectedTime}
                        selectedTime={selectedTime}
                        setScheduled={setScheduled}
                      />
                    ))}
                  </div>
                  <div className={`item-1 ${styles.map}`}>
                    <StaticMap
                      className={styles.mapContainer}
                      quality={QUALITY.pretty}
                      size={MAP_SIZE.small}
                      scale={MAP_SCALE.normal}
                      center={location}
                      markers={stores}
                    />
                  </div>
                </>
              ) : (
                <ErrorMessage
                  className="item-1 full-width full-height"
                  img={ERROR_IMAGES.notInArea}
                  title=""
                  message={t('DeliveryOrPickUp:noDataMessage')}
                  actionButtonText={t('DeliveryOrPickUp:tryAnotherAddress')}
                  actionButtonClassName="m-top-2 m-bottom-0"
                  action={onCleanSearchInput}
                />
              )}
            </div>
            {stores && this.storeInfo(cn({ [styles.storeInfoContainerBottom]: RENDER_CALL_CENTER }))}
          </>
        )}
      </>
    );
  }
}

PickUp.propTypes = {
  onAddressSelect: func.isRequired,
  onConfirm: func.isRequired,
  onStoreSelect: func.isRequired,
  changeTab: func,
  className: string,
  deliveryError: string,
  incompleteAddress: oneOfType([string, undefined]),
  isConfirmAddress: bool,
  loadingStores: bool,
  searchStore: object,
  selectedAddress: addressPropTypes,
  selectedDeliveryTime: object,
  selectedStore: storePropTypes,
  setScheduled: func,
  setSelectedDeliveryTime: func,
  stores: arrayOf(subsidiaryPropTypes),
  undoConfirmAddress: func,
  onCleanSearchInput: func,
  onDispatchChange: func,
  onSearchInputChange: func,
  onStoreBlur: func,
  onStoreFocus: func
};

export default PickUp;
